// GENERATED from backend/i18n_client.py by backend/tests/gen_en_client.py — do not edit.
const data = {
  "client": {
    "stage0": "Submitted",
    "stage1": "Payment Confirmed",
    "stage2": "Document Review",
    "stage3": "Government Filing",
    "stage4": "Delivered",
    "welcomeName": "Welcome back, {{name}}.",
    "founder": "founder",
    "dashSubtitle": "Track and manage your service requests.",
    "newRequest": "New request",
    "statTotal": "Total requests",
    "yourRequests": "Your requests",
    "loading": "Loading…",
    "noRequests": "No requests yet",
    "noRequestsBody": "Start your first incorporation to see it tracked here.",
    "browseServices": "Browse services",
    "bundle": "Bundle",
    "savedBundle": "You saved {{amount}} with this bundle",
    "completePayment": "Complete payment",
    "regNo": "Reg No. {{reg}}",
    "signOut": "Sign out",
    "myPayments": "My payments",
    "payPending": "Pending",
    "payPaid": "Paid",
    "payExpired": "Expired",
    "payNow": "Pay now",
    "payOpenError": "Could not open payment. Please try again.",
    "billedBy": "Payments are billed by {{name}}",
    "myDocuments": "My documents",
    "docPartial": "Partially uploaded",
    "docCompleted": "Completed",
    "uploadedCount": "{{done}}/{{total}} uploaded",
    "submitted": "Submitted",
    "forOrder": "Requested for your order",
    "docRequest": "Document request",
    "videoInstructions": "Video instructions",
    "uploaded": "Uploaded",
    "awaitingUpload": "Awaiting upload",
    "recordNow": "Record Now",
    "uploadVideo": "Upload Video",
    "replace": "Replace",
    "upload": "Upload",
    "docUploaded": "Document uploaded.",
    "uploadFailed": "Upload failed.",
    "uploadFailedRetry": "Upload failed. Please try again.",
    "badVideoType": "Unsupported video type. Upload an MP4, WEBM or MOV video.",
    "videoTooLarge": "Video is too large. Maximum size is 50 MB.",
    "badFileType": "Unsupported file type. Upload a PDF, image or Word doc.",
    "fileTooLarge": "File is too large. Maximum size is 25 MB.",
    "reqNotFoundToast": "Request not found.",
    "reqNotFound": "Request not found",
    "checkoutError": "Could not start checkout.",
    "backDashboard": "Back to dashboard",
    "dashboard": "Dashboard",
    "bundleSaving": "Bundle order — you saved <b>{{amount}}</b> by combining company formation and banking.",
    "docsAttentionOne": "1 document needs your attention. Please review the Documents section below.",
    "docsAttentionMany": "{{count}} documents need your attention. Please review the Documents section below.",
    "paymentPending": "Payment pending — {{amount}}",
    "completeToBegin": "Complete payment to begin processing.",
    "payAmount": "Pay {{amount}}",
    "status": "Status",
    "estCompletion": "Estimated completion:",
    "estimateOnly": "(estimate only)",
    "teamUpdates": "Updates from our team",
    "documents": "Documents",
    "uploadDoc": "Upload a document",
    "noDocs": "No documents requested yet. You can upload supporting documents any time, or your specialist will request what's needed here.",
    "dsRequired": "Required",
    "dsUploaded": "Uploaded",
    "dsUnderReview": "Under review",
    "dsApproved": "Approved",
    "dsRejected": "Rejected",
    "dsActionRequired": "Action required",
    "uploadedOn": "Uploaded {{date}}",
    "orderSummary": "Order summary",
    "total": "Total",
    "company": "Company",
    "companyName": "Company name",
    "entityType": "Entity type",
    "jurisdiction": "Jurisdiction",
    "contact": "Contact",
    "email": "Email",
    "directors": "Directors",
    "cameraDenied": "Camera access was denied. Please allow camera and microphone access in your browser, or use the Upload Video option instead.",
    "ulSecure": "Secure upload",
    "ulExpiredTitle": "This link has expired",
    "ulExpiredBody": "This secure upload link is no longer valid. Please contact UniIncorp to request a new one.",
    "ulContact": "Contact UniIncorp",
    "ulSubmittedTitle": "Documents submitted",
    "ulThanksName": "Thank you, {{name}}! Your documents have been received and sent to the UniIncorp team. We'll review them and be in touch. You can safely close this page.",
    "ulThanks": "Thank you! Your documents have been received and sent to the UniIncorp team. We'll review them and be in touch. You can safely close this page.",
    "ulHiName": "Hi {{name}}, please upload your documents",
    "ulHello": "Hello, please upload your documents",
    "ulDefaultMsg": "UniIncorp needs the following documents to proceed. Upload each item below, then tap Submit.",
    "ulAllUploaded": "All requested documents are uploaded. Tap <b>Submit Documents</b> below to finish.",
    "ulSubmit": "Submit Documents",
    "ulNeedOne": "Upload at least one document to submit.",
    "ulProgress": "{{n}} of {{total}} uploaded. You can submit now or add the rest first.",
    "ulSubmittedToast": "Documents submitted. Thank you!",
    "ulSubmitErr": "Could not submit. Please try again.",
    "ulFooter": "Secured by UniIncorp. This link is private to you and expires automatically. We never ask for passwords or payment details here.",
    "recordTitle": "Record video (max {{sec}} sec)",
    "document": "Document",
    "download": "Download",
    "reRecord": "Re-record",
    "useVideo": "Use this video",
    "stop": "Stop",
    "startRecording": "Start recording",
    "previewError": "Could not load this document.",
    "previewUnavailable": "Preview isn't available for this file type."
  }
};
export default data;
